import React, { useState, useEffect } from 'react';
import { Form, Input, InputGroup, InputGroupAddon } from "reactstrap";
import useGlobal from '../../store';
import LoadingOverlay from '../General/LoadingOverlay';
import CurrencySymbol from '../General/CurrencySymbol';

const AddItemForm = (props) => {

    const [showEntireForm, setShowEntireForm] = useState(false);
    const [isParsing, setIsParsing] = useState(false);

    const [formState, setFormState] = useState({
        itemURLs: '',
        itemPic: '',
        itemName: '',
        itemDescription: '',
        itemPrice: 0,
        brand: '',
        categories: '',
        itemID: null,
        sku: '',
        merchantID: ''
    });
    const [response, giftlistActions] = useGlobal(
        state => state.response,
        actions => actions.giftlistActions
    );

    const submitForm = async (event) => {
        event.preventDefault();
        console.log('submitting form...');
        const justFormData = new FormData(event.target);
        var object = {};
        justFormData.forEach((value, key) => {object[key] = value});
        let formData = { ...formState };
        //formData.itemPrice = formData.itemPrice.replace(/[^\d\.]/g, '');
        formData.itemID = null;
        formData.merchantID = '';
        formData.sku='';
        formData.brand ='';
        formData.categories = '';
        console.log('FORM DATA', formData);
        props.submitForm(formData);
    }

    const handleInputChange = (event) => {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        let formFields = { ...formState };

        if(name === "itemURLs" && value.indexOf("http") >= 0) {
            let adjValue = value.substr(value.indexOf("http"));
            formFields[name] = adjValue;
        } else {
            formFields[name] = value;
        }
        
        setFormState(formFields);
    }

    const parseUrl = () => {
        console.log('go parse...' + formState.itemURLs);
        setIsParsing(true);
        giftlistActions.parseUrl(formState.itemURLs);
    }

    useEffect(() => {
        if(!response || response.type !== "parseurl") {
            return;
        }
        console.log('GOT A PARSE RESPONSE!', response);
        setFormState(response.data);
        setShowEntireForm(true);
        setIsParsing(false);
    }, [response]);


    

    return (<>
        {isParsing ? <LoadingOverlay></LoadingOverlay> : <></>}
        <Form onSubmit={submitForm} className="kt-form p-3">
            <div className="form-group ">
                <label>Enter a website link (URL) where your item can be purchased.</label>
                <div className="input-group">
                    <input type="text" className="form-control" placeholder="http://www..." name="itemURLs" value={formState.itemURLs || ''} onChange={handleInputChange} />
                    <div className="input-group-append">
                        <button className="btn btn-primary" onClick={() => parseUrl()} type="button">Go!</button>
                    </div>
                </div>

                { showEntireForm ? <></> : 
                    <p>
                        <button onClick={() => setShowEntireForm(true)} className="btn btn-secondary mt-4">I don't have a link</button>
                </p> }
            </div>
            { showEntireForm ? <>
                <div className="form-group ">
                    <label>Item Name</label>
                    <input type="text" className="form-control" placeholder="Item Name" name="itemName" value={formState.itemName || ''} onChange={handleInputChange} />
                </div>
                <div style={{display:"flex"}}>
                    {formState.itemPic ? <img alt="new item" src={formState.itemPic} className="mr-2" style={{height:"70px",border:"1px solid #EFEFEF", borderRadius: "4px", padding: "2px"}} /> : <></> }
                    <div style={{width:"100%"}} className="form-group">
                        <label>Item Image URL</label>
                        <div className="input-group">
                            <input type="text" className="form-control" placeholder="Item Image URL" name="itemPic" value={formState.itemPic || ''} onChange={handleInputChange} />
                            <div className="input-group-append">
                                <button className="btn btn-secondary" type="button">
                                    <i className="flaticon-photo-camera"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="form-group ">
                    <label>Helpful details or notes</label>
                    <Input type="textarea" name="itemDescription" value={formState.itemDescription || ''} onChange={handleInputChange} />
                </div>

                <div className="form-group">
                    <label>Price</label>
                    <InputGroup>
                        <InputGroupAddon addonType="prepend"><CurrencySymbol></CurrencySymbol></InputGroupAddon>
                        <Input placeholder="Amount" name="itemPrice" value={formState.itemPrice || '0'} onChange={handleInputChange} />
                    </InputGroup>
                </div>


                <div className="form-group">
                    <button className="btn btn-success btn-block" type="submit">
                        <i className="flaticon-plus"></i> 
                        Add Item {props.selectedUser ? 'for ' + props.selectedUser.FirstName : ''}
                    </button>
                </div>
                </> : <></> }

            
        </Form>
        </>);
}
export default AddItemForm;